import { MatCheckboxModule } from '@angular/material/checkbox';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatSelectModule } from '@angular/material/select';
import { MatTableModule } from '@angular/material/table';
import { FuseSharedModule } from '@fuse/shared.module';
import { FuseSidebarModule, FuseWidgetModule } from '@fuse/components';
import { MatInputModule } from '@angular/material/input';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatChipsModule } from '@angular/material/chips';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatRippleModule } from '@angular/material/core';
import { MatSortModule } from '@angular/material/sort';
import { MatTabsModule } from '@angular/material/tabs';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { PipesModule } from 'app/pipes/pipes.module';
import { OwlDateTimeModule, OwlNativeDateTimeModule } from 'ng-pick-datetime';
import { TranslateModule } from '@ngx-translate/core';
import { AgmCoreModule } from '@agm/core';
import { MapComponent } from './maps/map.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MarkerFormComponent } from './marker-form/marker-form.component';
import { PoligonFormComponent } from './poligon-form/poligon-form.component';
import { DriverMapComponent } from './driver-map/driver-map.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { SimulationComponent } from '../simulation-map/simulation/simulation.component';
import { MapContainerFormComponent } from './map-container-form/map-container-form.component';
import { DriverProcessService } from 'app/services/driver-process.service';
import { EnvanterFormComponent } from './envanter-form/envanter-form.component';
import { EnvanterService } from 'app/services/envanter.service';
import { DriverFinishConfirmationComponent } from './driver-finish-confirmation/driver-finish-confirmation.component';
import { GarbageCenterFormComponent } from './garbage-center-form/garbage-center.component';
import {MatAutocompleteModule} from '@angular/material/autocomplete';


@NgModule({
    declarations: [MapComponent, GarbageCenterFormComponent,DriverFinishConfirmationComponent, MarkerFormComponent, MapContainerFormComponent, PoligonFormComponent, DriverMapComponent, SimulationComponent, EnvanterFormComponent],
    imports: [
        CommonModule,
        MatButtonModule,
        MatDividerModule,
        MatFormFieldModule,
        MatIconModule,
        MatMenuModule,
        MatSelectModule,
        MatTableModule,
        BrowserAnimationsModule,
        MatCheckboxModule,
        FuseSharedModule,
        MatTooltipModule,
        FuseSidebarModule,
        FuseWidgetModule,
        MatChipsModule,
        MatAutocompleteModule,
        MatExpansionModule,
        MatInputModule,
        MatPaginatorModule,
        MatRippleModule,
        MatSortModule,
        MatTabsModule,
        MatSnackBarModule,
        MatIconModule,
        PipesModule,
        OwlDateTimeModule,
        OwlNativeDateTimeModule,
        TranslateModule,
        FormsModule,
        AgmCoreModule.forRoot({
            apiKey: 'AIzaSyD81ecsCj4yYpcXSLFcYU97PvRsE_X8Bx8'
        })
    ],
    providers: [DriverProcessService,EnvanterService]
})
export class MapModule { }
